import {
  Box,
  Stack,
  Button,
  Heading,
  useColorModeValue,
  Center,
  Image,
} from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import FormLayoutProvider from "../../layout/FormLayoutProvider.jsx";

export default function MembershipLogin() {
  const navigate = useNavigate();

  const { t } = useTranslation();

  return (
    <FormLayoutProvider>
      <Stack spacing={8} mx={"auto"} maxW={"lg"} py={12}>
        <Box
          rounded={"lg"}
          bg={useColorModeValue("white", "gray.700")}
          boxShadow={"lg"}
          p={8}
          h="50vh"
        >
          <Stack spacing={4}>
            <Stack align={"center"}>
              <Heading fontSize={"xl"}>Join with Us</Heading>
            </Stack>

            <Image src="https://pororo-prod.oss-ap-southeast-5.aliyuncs.com/img/menu/215638eb-300e-430a-b3b5-714b1df3030d.png" />

            <Button
              type="submit"
              onClick={() => navigate("/membership/register")}
              bg={"red.400"}
              color={"white"}
              _hover={{
                bg: "red.500",
              }}
            >
              {t("register")}
            </Button>

            <Center>
              <p>{t("already_have_account")}</p>
              <Button
                mx={4}
                variant="link"
                onClick={() => navigate("/membership/login")}
              >
                {t("login")}
              </Button>
            </Center>
          </Stack>
        </Box>
      </Stack>
    </FormLayoutProvider>
  );
}
